import React from 'react'
import {renderMoney} from '../../utils'
import Config from '../../config'


export default class WKPgyShare extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {role} = this.props

        return (
            <div className="wk-pgy-share" style={{top: this.props.top}}>
                {(role === 2 || role === 3) &&
                <a href={`${Config.PGY_MALL_URL}/sharecard/channel/${this.props.id}${location.search}`} className="wk-pgy-share__member">
                    <span className="wk-pgy-share__money">
                        <img className="wk-pgy-share__font" src="https://static-1253442168.image.myqcloud.com/picture/7832811_eb6965b02f99052516cb6da1bb7671a4.jpg"/>
                        <span>返￥{renderMoney(this.props.money)}</span>
                    </span>
                </a>
                }
                {role === 1 &&
                <a href={`${Config.PGY_MALL_URL}/memberDescribe${location.search}`} className="wk-pgy-share__member">
                    <span className="wk-pgy-share__origin">加入会员返￥{renderMoney(this.props.money)}</span>
                </a>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/wk/WKPgyShare.js